import { BreachEvent } from '@news-mono/web-common'
import React from 'react'
import { MessageBanner } from '../../../../../banners/MessageBanner/MessageBanner'
import { StyledWestRewardsMessage } from './BlackFridayComponents/BlackFridayWestRewardsMessage.styled'
import BlackFridayBreachContent from './BlackFridayBreachContent'
export interface BreachNotificationProps {
    breachCreativeName: string
    breachDeal: string
    onEvent: (event: BreachEvent) => void
}

export function BlackFridayBreachNotification({
    breachDeal,
    breachCreativeName,
    onEvent,
}: BreachNotificationProps) {
    return (
        <div data-testid="BreachScreen">
            <MessageBanner
                icon="subscriber"
                connector="solid-arrow"
                onEvent={onEvent}
            >
                <p>
                    This article is available to subscribers who have digital
                    access included in their subscription.
                </p>
            </MessageBanner>

            <BlackFridayBreachContent
                breachDeal={breachDeal}
                breachCreativeName={breachCreativeName}
                onEvent={onEvent}
                title="40% off subscriptions."
                message={<p>Black Friday Sale on now.<br /> Ends midnight, Monday.</p>}
                cta="View Packages"
                subscriptionPackages={[
                    {
                        packagePath: 'offercheck/thewest',
                        offerCode: 'BLKFRI1',
                        pretitle: 'Digital',
                        originalPrice: '$7 per week',
                        heading: 'Everyday Digital',
                        price: '$4.20  per week',
                        priceQualifier: 'for 8 weeks*',
                        packageType: 'digital',
                        cancellationMessage: 'Cancel anytime. Min cost $14.',
                    },
                    {
                        ribbonTitle: 'Most popular',
                        pretitle: 'Digital & Print',
                        heading: 'Weekend Papers + Everyday Digital',
                        originalPrice: '$9 per week',
                        price: '$5.40 per week',
                        priceQualifier: 'for 8 weeks*',
                        packagePath: 'offercheck/thewest',
                        offerCode: 'BLKFRI2',
                        packageType: 'digitalprint',
                        cancellationMessage: 'Cancel anytime. Min cost $18.',
                    },
                ]}
            />
            <StyledWestRewardsMessage />
        </div>
    )
}
